var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4523 0.585787C21.1826 1.36684 21.1826 2.63317 20.4523 3.41421L9.23149 15.4142C8.88077 15.7893 8.4051 16 7.90911 16C7.41312 16 6.93744 15.7893 6.58673 15.4142L0.976337 9.41421C0.246006 8.63317 0.246006 7.36683 0.976337 6.58579C1.70667 5.80474 2.89077 5.80474 3.6211 6.58579L7.90911 11.1716L17.8075 0.585787C18.5378 -0.195262 19.7219 -0.195262 20.4523 0.585787Z",
    fill: "#737088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleGrayCheck);
export default __webpack_public_path__ + "static/media/single-gray-check.768d421dd57e3421f3825d48a548bd52.svg";
export { ForwardRef as ReactComponent };